"use client";
import EmptyState from "../../../components/custom/empty-state";
import {
  CLOTHING_CATEGORY_STATUS,
  CLOTHING_CATEGORY_STATUS_NAME,
} from "../services/clothing-category-service";

export interface ClothingCategoryRow {
  id: number;
  name: string;
  code?: string | null;
  sort_order: number;
  status: number;
  created_at: string;
}

interface ClothingCategoriesTableProps {
  rows: ClothingCategoryRow[];
  isLoading: boolean;
  onEdit?: (row: ClothingCategoryRow) => void;
}

const statusColor: Record<number, string> = {
  [CLOTHING_CATEGORY_STATUS.ACTIVE]: "bg-green-100 text-green-800",
  [CLOTHING_CATEGORY_STATUS.INACTIVE]: "bg-red-100 text-red-800",
};

const ClothingCategoriesTable: React.FC<ClothingCategoriesTableProps> = ({
  rows,
  isLoading,
  onEdit,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-16 text-gray-400">
        <svg className="animate-spin h-6 w-6 mr-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
        <span className="text-sm font-medium">Đang tải dữ liệu...</span>
      </div>
    );
  }

  if (!rows.length) {
    return <EmptyState message="Chưa có loại đồ nào" description="Thêm loại đồ mới để bắt đầu" />;
  }

  return (
    <table className="min-w-full border text-sm">
      <thead className="bg-gray-100">
        <tr>
          <th className="border px-3 py-2 text-center w-16">STT</th>
          <th className="border px-3 py-2 text-left">Tên loại đồ</th>
          <th className="border px-3 py-2 text-center">Mã</th>
          <th className="border px-3 py-2 text-center w-24">Thứ tự</th>
          <th className="border px-3 py-2 text-center">Trạng thái</th>
          <th className="border px-3 py-2 text-center w-24">Thao tác</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={row.id} className="hover:bg-gray-50">
            <td className="border px-3 py-2 text-center">{idx + 1}</td>
            <td className="border px-3 py-2 font-medium">{row.name}</td>
            <td className="border px-3 py-2 text-center font-mono text-gray-500">
              {row.code || "\u2014"}
            </td>
            <td className="border px-3 py-2 text-center">{row.sort_order}</td>
            <td className="border px-3 py-2 text-center">
              <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-medium ${statusColor[row.status] || "bg-gray-100 text-gray-800"}`}>
                {CLOTHING_CATEGORY_STATUS_NAME[row.status] || "\u2014"}
              </span>
            </td>
            <td className="border px-3 py-2">
              <div className="flex justify-center gap-2">
                {onEdit && (
                  <button
                    type="button"
                    onClick={() => onEdit(row)}
                    aria-label="Sửa"
                    className="group/action relative grid h-9 w-9 place-items-center rounded-full bg-yellow-500 text-white shadow-sm hover:bg-yellow-600"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
                        className="h-4 w-4">
                      <path strokeLinecap="round" strokeLinejoin="round"
                            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652l-9.547
                              9.546a4.5 4.5 0 01-1.897 1.13l-3.034.909.91-3.034a4.5
                              4.5 0 011.129-1.897l9.547-9.546z"/>
                    </svg>
                    <span className="pointer-events-none absolute -top-8 left-1/2 hidden -translate-x-1/2 rounded-md bg-slate-900 px-2 py-1 text-xs text-white group-hover/action:block">
                      Sửa
                    </span>
                  </button>
                )}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ClothingCategoriesTable;
